module.exports = __webpack_public_path__ + "static/media/id-validity-2012.dbb32641.jpg";